// extracted by mini-css-extract-plugin
module.exports = {"menu":"CustomMenu_menu__31RgX","error":"CustomMenu_error__QbBTO","menuItem":"CustomMenu_menuItem__Ztyq5","popOver":"CustomMenu_popOver__2EeJV"};